const setNameValue = () => {
  const reviewApp = document.querySelector('#judgeme_product_reviews');

  if (reviewApp) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const nameInput = reviewApp.querySelector('.jdgm-form-wrapper input[name="reviewer_name"]');
          const nameWrapper = nameInput.parentNode;
          
          if (nameInput) {
            nameWrapper.style.display = 'none';
            nameInput.value = "匿名";

            // 目的の要素が見つかったらオブザーバーを停止
            observer.disconnect();
          }
        }
      });
    });

    observer.observe(reviewApp, { childList: true, subtree: true });
  }
}

window.addEventListener('DOMContentLoaded', setNameValue);
